import { useAuth } from 'client/lib/auth';
import { useEffect, useMemo } from 'preact/hooks';

type Part = string | undefined;

export function concatDocumentTitle(...parts: Part[]) {
  let result = '';
  for (const part of parts) {
    if (result.length && part) {
      result += ' | ';
    }
    if (part) {
      result += part;
    }
  }
  return result;
}

/*
 * Updates the document title. The site name is appended unless
 * `siteName: false` (campaign pages show their title exactly as entered).
 */
export function useDocumentTitle(rawParts: Part[], opts?: { siteName?: boolean }) {
  const withSiteName = opts?.siteName !== false;
  const tenant = useAuth().config?.tenant;
  const parts = useMemo(() => rawParts, rawParts);

  useEffect(() => {
    // The tenant can be null in certain error condtions,
    // and we still use the document title on error pages,
    // so we need to handle this.
    const currentTenant = tenant || {
      name: '',
    };

    document.title = concatDocumentTitle(...parts, withSiteName ? currentTenant.name : undefined);

    return () => {
      document.title = currentTenant.name;
    };
  }, [parts, tenant, withSiteName]);
}
